// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__17nM-","footer":"ReportModalFilter_footer__1QKNu"};